<app-dialog-header [title]="'GENERAL.LABEL.EDIT_RELEVANT_EXECUTIONS'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24 pb-0" fxLayout="column" fxLayoutAlign="start">
    <div class="module-modes mb-24">
        <mat-button-toggle-group [formControl]="relevantExecutionsMode" appearance="legacy" class="mat-elevation-z0 rounded-sm bg-white border border-gray-300">
            <mat-button-toggle value="in_date_range">{{ 'GENERAL.LABEL.IN_DATE_RANGE' | translate }}</mat-button-toggle>
            <mat-button-toggle value="manage_manually">{{ 'GENERAL.LABEL.MANAGE_MANUALLY' | translate }}</mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <div class="p-24 pb-4 bg-zinc-50 rounded-sm" *ngIf="relevantExecutionsMode.value === 'in_date_range'">
        <p class="text-gray-600 text-base font-normal mb-12">{{ 'PAGE.DIALOG.EDIT_RELEVANT_EXECUTIONS.LABEL.IN_DATE_RANGE' | translate }}</p>

        <form fxLayout="row" [formGroup]="formGroup" class="w-100-p">
            <mat-form-field class="w-100-p mr-16">
                <input
                    matInput
                    name="startDate"
                    formControlName="startDate"
                    [matDatepicker]="pickerStartDate"
                    [placeholder]="'GENERAL.PROPERTY.START_DATE' | translate"
                    (focus)="pickerStartDate.open()"
                />
                <mat-datepicker-toggle matSuffix [for]="pickerStartDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerStartDate></mat-datepicker>

                <mat-error *ngIf="formGroup.controls['startDate'].errors && formGroup.controls['startDate'].errors['message']">
                    {{ 'ERROR.RESPONSE.' + formGroup.controls['startDate'].errors['message'] | translate }}
                </mat-error>
            </mat-form-field>

            <mat-form-field class="w-100-p">
                <input
                    matInput
                    name="endDate"
                    formControlName="endDate"
                    [matDatepicker]="pickerEndDate"
                    [placeholder]="'GENERAL.PROPERTY.END_DATE' | translate"
                    (focus)="pickerEndDate.open()"
                />
                <mat-datepicker-toggle matSuffix [for]="pickerEndDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerEndDate></mat-datepicker>
                <mat-error *ngIf="formGroup.controls['endDate'].errors && formGroup.controls['endDate'].errors['message']">
                    {{ 'ERROR.RESPONSE.' + formGroup.controls['endDate'].errors['message'] | translate }}
                </mat-error>
            </mat-form-field>
        </form>
    </div>
</div>

<div mat-dialog-actions class="p-24" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button
        [label]="'GENERAL.BUTTON.SAVE'"
        (onClick)="save()"
        [disabled]="(formGroup.controls['startDate'].invalid || formGroup.controls['endDate'].invalid) && relevantExecutionsMode.value === 'in_date_range'"
    ></app-flat-button>
</div>
